<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Settings</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active"> Site Logo & Favicon
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4 class="card-title">Site Logo</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="updateSiteLogo()">
                        <div class="row">
                            <div class="col-6 mb-3">
                                <file-pond
                                    v-if="true"
                                    name="test"
                                    ref="logo"
                                    label-idle="Drag & drop Site logo"
                                    accepted-file-types="image/jpeg, image/png, image/gif"
                                    data-allow-reorder="true"
                                    data-max-file-size="2MB"
                                    :files="logo"
                                />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <button class="btn btn-primary" v-if="!saving">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            <section class="card">
                <div class="card-header">
                    <h4 class="card-title">Site Favicon</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="updateSiteFavicon()">
                        <div class="row">
                            <div class="col-6 mb-3">
                                <file-pond
                                    v-if="true"
                                    name="test"
                                    ref="favicon"
                                    label-idle="Drag & drop sites favicon"
                                    :allow-multiple="false"
                                    accepted-file-types="image/jpeg, image/png, image/gif"
                                    data-allow-reorder="true"
                                    data-max-file-size="2MB"
                                    :files="favicon"
                                />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <button class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from "../../Shared/Layout";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import {VueEditor} from "vue2-editor";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";


const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);

export default {
    metaInfo: {title: 'Edit Logo and favicon'},
    name: 'EditLogo',
    props: ['settingsData'],
    components: {
        VueEditor,
    },
    layout: Layout,
    data() {
        return {
            saving: false,
            setting: [],
            logo: [],
            favicon: [],
        }
    },
    methods: {
        async updateSiteLogo() {
            this.saving = true;
            const formData = new FormData();

            try {

                if (this.$refs.logo.getFile().source !== this.$refs.logo.files) {
                    const uploadedFile = this.$refs.logo.getFile();

                    formData.append('site_logo', uploadedFile.file);

                    this.postRequest(formData, 'admin.settings.store-logo');
                }
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },

        async updateSiteFavicon() {
            this.saving = true;
            const formData = new FormData();

            try {

                if (this.$refs.favicon.getFile().source !== this.$refs.favicon.files) {
                    const uploadedFile = this.$refs.favicon.getFile();

                    formData.append('site_favicon', uploadedFile.file);

                    this.postRequest(formData, 'admin.settings.store-favicon');
                }
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
        postRequest(formData, routes) {
            this.$inertia.post(route(routes), formData, {
                preserveScroll: true,
                onError: () => this.saving = false,
                onSuccess: () => this.saving = false,
            });
        }
    },
    mounted() {
        let data = Object.keys(this.settingsData);
        if (data.length) {
            this.logo = this.settingsData.site_logo;
            this.favicon = this.settingsData.site_favicon
        }
    },
}
</script>
